import { ValueOf } from '@approvalmax/types';
import { ExpandedCompany } from 'modules/common/selectors/types';
import { domain } from 'modules/data';
import { CompaniesItem } from 'shared/data/webApp/v2';

export const isOcrEnableForCompany = (company: ExpandedCompany) => {
    return isOcrEnabledByFeatures({
        licenseFeatures: company.licenseFeatures,
        allFeaturesTrialStatus: company.allFeaturesTrialStatus,
        licenseProductPlan: company.licenseProductPlan,
        integrationType: company.integration?.integrationType,
        betaFeatures: company.betaFeatures,
    });
};

export const isOcrEnableForCompanyV2 = (company: CompaniesItem) => {
    // TODO: get rid of type assertions after refactoring: AM-24375
    return isOcrEnabledByFeatures({
        licenseFeatures: company.productPlanFeatures as domain.CompanyLicenseFeature[],
        allFeaturesTrialStatus: company.allFeaturesTrialStatus,
        licenseProductPlan: company.productPlanId as domain.CompanyPlan,
        integrationType: company.integrationType,
        betaFeatures: company.betaFeatures as domain.CompanyBetaFeature[],
    });
};

export const isOcrEnabledByFeatures = ({
    licenseFeatures,
    allFeaturesTrialStatus,
    licenseProductPlan,
    integrationType,
    betaFeatures,
}: {
    licenseFeatures: domain.CompanyLicenseFeature[];
    allFeaturesTrialStatus: ValueOf<domain.AllFeaturesTrialStatus>;
    licenseProductPlan: domain.CompanyPlan;
    integrationType?: ValueOf<domain.IntegrationType>;
    betaFeatures: domain.CompanyBetaFeature[];
}) => {
    const ocrEnabled =
        licenseFeatures.includes(domain.CompanyLicenseFeature.Capture) ||
        allFeaturesTrialStatus === domain.AllFeaturesTrialStatus.Active ||
        licenseProductPlan === domain.CompanyPlan.Trial;

    if (!integrationType) {
        return false;
    }

    switch (integrationType) {
        case domain.IntegrationType.NetSuite:
            return betaFeatures.includes(domain.CompanyBetaFeature.CaptureNetSuiteBill);

        case domain.IntegrationType.Xero:
            return (
                ocrEnabled ||
                betaFeatures.includes(domain.CompanyBetaFeature.XeroOcr) ||
                betaFeatures.includes(domain.CompanyBetaFeature.CaptureXeroPurchaseOrder) ||
                betaFeatures.includes(domain.CompanyBetaFeature.CaptureXeroSalesInvoice) ||
                betaFeatures.includes(domain.CompanyBetaFeature.CaptureXeroAPCreditNote)
            );

        case domain.IntegrationType.QBooks:
            return (
                ocrEnabled ||
                betaFeatures.includes(domain.CompanyBetaFeature.CaptureQBOBill) ||
                betaFeatures.includes(domain.CompanyBetaFeature.CaptureQBOExpense)
            );

        default:
            return false;
    }
};
